export default "__VITE_ASSET__Lmog4Yxf__"